import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Axios from '../../config/Axios';
import './styles/documentaccess.scss'; // Certifique-se de que o caminho do arquivo esteja correto
import Login from '../login/Login';
import { BrandTitle } from '../../config/ApperanceContext';

import FroalaEditorComponent from '../../config/FroalaEditorComponent';
import 'froala-editor/css/froala_style.min.css';
import '../../assets/scss/froala-custom.scss';

import SweetAlert from 'react-bootstrap-sweetalert/lib/dist/SweetAlert';
import PdfFireViewer from '../../components/PdfFireViewer';
import clipIcon from '../../assets/img/clip.svg';
import { fnGetImageAttachment } from '../../actions/ActionDocumentDetails';
import '../../pages/document/styles/documentshared.scss';



const DocumentAccess = () => {
  const params = useParams();
  const { hash } = params;
  const [document, setDocument] = useState(null);
  const [error, setError] = useState('');
  const [isLoginVisible, setIsLoginVisible] = useState(false);
  const [showRestrictedMessage, setShowRestrictedMessage] = useState(false);

  const [alert, setAlert] = useState(null);
  const [showSpinner, setShowSpinner] = useState(false);


  useEffect(() => {
    Axios.get(`/document/share/${hash}`)
      .then(response => {
        localStorage.setItem("sHash", hash);
        setDocument(response.data);
      })
      .catch(err => {
        if (err.response?.status === 403) {
          const { share_link, sHash } = err.response.data;
          localStorage.setItem('share_link', share_link);
          localStorage.setItem('sHash', sHash);
          if (localStorage.getItem("cStorageToken") && localStorage.getItem("cStorageToken").length > 0) {
            window.location.href = share_link;
          }
          setShowRestrictedMessage(true);
          setTimeout(() => {
            setIsLoginVisible(true);
            setShowRestrictedMessage(false);
          }, 5000); // 5 seconds delay before showing the login screen
        } else {
          setError(err.response?.data?.message || 'Problema com código de acesso ou documento inexistente.');
        }
      });
  }, [hash]);

  const handleLoginSuccess = () => {
    const storedHash = localStorage.getItem('sHash');
    Axios.get(`/document/share/${storedHash}`)
      .then(response => {
        setDocument(response.data);
        setIsLoginVisible(false);
      })
      .catch(err => setError(err.response?.data?.message || 'Problema com código de acesso ou documento inexistente.'));
  };

  const handleDownloadAttachment = (evt, attachment) => {
    evt.preventDefault();
    const fileType = attachment.atch_cname.split('.').pop().toLowerCase();
    setShowSpinner(true);
  
    fnGetImageAttachment(attachment.atch_nid, attachment.atch_cname, false, 'public')
      .then(oData => {
        const bPreviewUnavailable = oData?.cType === 'unavailable';
        let content = oData.cContent;
        if (oData.cType === 'base64') {
          content = "data:image/png;base64, " + oData.cContent;
        }
        if (oData.cType === 'application/pdf') {
          content = oData.cContent;
        }
  
        setAlert(
          <SweetAlert
            customClass="modal-edit modalMedium scrollBar"
            title=""
            onConfirm={() => setAlert(null)}
            showConfirm={false}
          >
            <div className="head-modal">
              Visualizar Anexo
              <span
                role="button"
                tabIndex="0"
                aria-labelledby="head-modal"
                onClick={() => setAlert(null)}
                className="close"
              />
            </div>
            {['png', 'jpg', 'jpeg', 'bmp'].includes(fileType) ? (
              <img className="attachment-image" src={content} />
            ) : (
              fileType === 'pdf' ? (
                <PdfFireViewer
                  pdfBlob={bPreviewUnavailable ? "" : content}
                  canDownload={true}
                  downloadUrl={oData?.cOriginalUrl || ""}
                  downloadFileName={oData?.cOriginalFileName || attachment.atch_cname}
                  fallbackReason={bPreviewUnavailable ? oData?.cReason : null}
                />
              ) : (
                <PdfFireViewer
                  pdfBlob={bPreviewUnavailable ? "" : `data:application/pdf;base64, ${content}`}
                  canDownload={true}
                  nameFile={attachment.atch_cname}
                  downloadUrl={oData?.cOriginalUrl || ""}
                  downloadFileName={oData?.cOriginalFileName || attachment.atch_cname}
                  fallbackReason={bPreviewUnavailable ? oData?.cReason : null}
                />
              )
            )}
          </SweetAlert>
        );
        setShowSpinner(false);
      })
      .catch(() => setShowSpinner(false));
  };
  

  return (
    <div className="body-background">
      {alert}
      {showSpinner && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <p style={{ color: '#fff' }}>Carregando anexo...</p>
        </div>
      )}
      {showRestrictedMessage ? (
        <div className="error-message">
          <div>
            <h2>Documento restrito</h2>
            <p>Você precisa estar logado no sistema para acessar este documento. Redirecionando em 5 segundos...</p>
          </div>
        </div>
      ) : isLoginVisible ? (
        <Login onSuccess={handleLoginSuccess} />
      ) : (
        document ? (
          <div className="document-view">
            <header>
              <div className="logo">
                {document.aCustomer.cust_clogo && <img src={document.aCustomer.cust_clogo} alt={document.aCustomer.cust_cname} />}
              </div>
              <div className="company-info">
                <h1>{document.aCustomer.cust_cname}</h1>
                <div className="title"><strong>{document.aDocument.doc_ctitle}</strong></div>
              </div>
            </header>
            <main>
              <div className="details">
                <div><strong>Responsável:</strong> {document.responsible_name}</div>
                <div><strong>Redator:</strong> {document.writer_name}</div>
                <div><strong>Revisor:</strong> {document.reviewer_name}</div>
                <div><strong>Versão:</strong> {document.aVersionLatest.ver_cnumber}</div>
              </div>
              <div className="published-edited">
                <div><strong>Publicado em:</strong> {new Date(document.aVersionLatest.ver_dpublished).toLocaleDateString()}</div>
                <div><strong>Editado em:</strong> {new Date(document.aVersionLatest.ver_drevised).toLocaleDateString()}</div>
              </div>
              {/* Conteúdo Froala */}
              <div className="content fr-wrapper">
                <FroalaEditorComponent
                  model={document.aVersionLatest.ver_ctext || ''}
                  bReadOnly={true}
                />
              </div>

              {/* Bloco de anexos (sem verificação de permissão) */}
              {document.aVersionLatest.aAttachments?.length > 0 && (
                <div className="attachments-container">
                  <div className="attachments-wrapper">
                    <span>Anexos:</span>
                    <ul className="attachments">
                      {document.aVersionLatest.aAttachments.map((attachment) => (
                        <li key={attachment.atch_nid}>
                          <a
                            className="download-file-attachment"
                            onClick={(evt) => handleDownloadAttachment(evt, attachment)}
                          >
                            <img className="align clip-icon" src={clipIcon} alt="attachment icon" />
                            <span> {attachment.atch_cname}</span>
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}

            </main>
            <footer>
              <p>
                <a href="/" target="_blank" rel="noopener noreferrer">© <BrandTitle /></a>
              </p>
            </footer>
          </div>
        ) : (
          <div className="error-message">
            <div>
              <h2>Acessando o documento</h2>
              {error && <p>{error}</p>}
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default DocumentAccess;
